export default class ForageMethods {
  static GET = "get";
  static SET = "set";
}
